module.exports = __webpack_public_path__ + "a985283699f6fc6ba9cc7ac86c2450d6.png";